module.exports = __webpack_public_path__ + "assets/images/b0a3ccd413d19908383e6958b1e2f737.png";